<div *ngIf="is_no_data">
  <div class="col-12 mb-3 p-1" >
      <div class="card">
          <div class="card-body">
              <a class="t" style="font-size: medium;color: black;">{{'COMMON.MESSAGES.SPORT-NO-EVENT' | translate}}</a>
          </div>
      </div>
  </div>
</div>

<div class="container mt-2 pb-4" [hidden]="viewSelectionBlock" style="margin-bottom: 70px;">

  <div class="row">
    <div class="betting-category mb-2" id="dropdown"  *ngFor="let odd of ODDs; index as i" >
      <div class="d-flex" id="scrollto{{i}}" style="padding-top: 8px;padding-bottom: 8px;">
        <div class="d-flex flex-column">
          <span class="t-meeting-h">{{odd.eventLabel}}</span>
          <span class="t-faded t-meeting-l">{{odd.eventName}}</span>
        </div>
        <div class="extra d-flex">
          <div class="d-flex flex-column align-items-end">
            <span class="t">{{odd.eventTime}}</span>
            <span class="t-faded t-smaller">{{odd.eventLocalDate}}</span>
          </div>
          <a (click)="viewRaceDetails(odd,$event,i)" class="btn btn-tertiary icon ml-2">
            <span class="icon icon-arrow-right"></span>
          </a>
            

        <button [disabled]="odd.eventLabel.substr(odd.eventLabel.length-3,2) =='VR' || (!is_logged && odd.eventLabel.substr(odd.eventLabel.length-3,2) == 'AU')" (click)="viewInfoDetails(odd)" 
        class="btn btn-tertiary icon ml-2">
        <span  class="icon icon-info" ></span>
      </button>


        </div>
      </div>
    </div>
  </div>
</div>



<app-race-details  *ngIf="viewSelectionBlock" [selectedMeeting]="selectedMeeting"  [betcatselection]="betcatselection"></app-race-details><br />

